import { createReducer } from 'utils/redux'

const defaultState = {}
const setClassifications = ({ action }) => action.classifications

const actions = {
  RECEIVE_CLASSIFICATIONS: setClassifications,
}

const classificationsReducer = createReducer(defaultState, actions)

export default classificationsReducer
